var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1414_259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 3.40625C9.04515 3.40625 3.40625 9.04718 3.40625 16C3.40625 22.9569 9.04515 28.5938 16 28.5938C22.9548 28.5938 28.5938 22.9569 28.5938 16C28.5938 9.04718 22.9548 3.40625 16 3.40625ZM16 26.1562C10.387 26.1562 5.84375 21.6148 5.84375 16C5.84375 10.3889 10.3872 5.84375 16 5.84375C21.6109 5.84375 26.1562 10.3872 26.1562 16C26.1562 21.6129 21.6148 26.1562 16 26.1562ZM21.446 13.1969C21.446 16.6019 17.7684 16.6543 17.7684 17.9126V18.2344C17.7684 18.5709 17.4955 18.8438 17.159 18.8438H14.841C14.5044 18.8438 14.2316 18.5709 14.2316 18.2344V17.7947C14.2316 15.9795 15.6078 15.2539 16.6477 14.6708C17.5395 14.1709 18.086 13.8308 18.086 13.1687C18.086 12.293 16.9689 11.7117 16.0658 11.7117C14.8882 11.7117 14.3446 12.2691 13.5804 13.2335C13.3744 13.4935 12.9985 13.5418 12.7341 13.3414L11.3212 12.27C11.0618 12.0734 11.0037 11.7081 11.1869 11.4391C12.3867 9.67728 13.9149 8.6875 16.2942 8.6875C18.7861 8.6875 21.446 10.6326 21.446 13.1969ZM18.1328 21.6875C18.1328 22.8635 17.176 23.8203 16 23.8203C14.824 23.8203 13.8672 22.8635 13.8672 21.6875C13.8672 20.5115 14.824 19.5547 16 19.5547C17.176 19.5547 18.1328 20.5115 18.1328 21.6875Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1414_259"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "currentColor",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.dcd555460f2ea5179bc89bb6a2bde097.svg";
export { ForwardRef as ReactComponent };